import { AppointmentStatus } from "../interfaces/services/Appointment";

export const trimSecondsFromTime = (time?: string) => {
  if (!time || typeof time !== "string" || !time.includes(":")) return "00:00";
  const [hour, minute] = time.split(":");
  const fixedHour = hour.padStart(2, "0");
  const fixedMinute = minute.padStart(2, "0");
  return `${fixedHour}:${fixedMinute}`;
};

export const translateMonthToTurkish = (month: string): string => {
  const months: Record<string, string> = {
    January: "Ocak",
    February: "Şubat",
    March: "Mart",
    April: "Nisan",
    May: "Mayıs",
    June: "Haziran",
    July: "Temmuz",
    August: "Ağustos",
    September: "Eylül",
    October: "Ekim",
    November: "Kasım",
    December: "Aralık",
  };
  return months[month] || month;
};

export const translateDayToTurkish = (day: string): string => {
  const days: Record<string, string> = {
    Sunday: "Pazar",
    Monday: "Pazartesi",
    Tuesday: "Salı",
    Wednesday: "Çarşamba",
    Thursday: "Perşembe",
    Friday: "Cuma",
    Saturday: "Cumartesi",
  };
  return days[day] || day;
};

export const translateUserTypeToTurkish = (type: string): string => {
  const types: Record<string, string> = {
    Admin: "Yönetici",
    SalonOwner: "Salon Sahibi",
    Employee: "Çalışan",
    Customer: "Müşteri",
  };
  return types[type] || type;
};

export const translateRoleToTurkish = (role: string): string => {
  const roles: Record<string, string> = {
    Administrator: "Yönetici",
    Employee: "Çalışan",
    Customer: "Müşteri",
    Receptionist: "Resepsiyonist",
    Accountant: "Muhasebeci",
    "Inventory Manager": "Envanter Yöneticisi",
    "Service Manager": "Servis Yöneticisi",
    Barber: "Berber",
    hairdresser: "Kuaför",
  };

  // Büyük/küçük harf duyarlılığını azaltmak için normalize et
  const normalizedKey = Object.keys(roles).find(
    (key) => key.toLowerCase() === role.toLowerCase()
  );

  return normalizedKey ? roles[normalizedKey] : role;
};

export const translateSalonTypeToTurkish = (type: string): string => {
  const types: Record<string, string> = {
    BeautySalon: "Güzellik Salonu",
    AestheticClinic: "Estetik Kliniği",
    HairSalon: "Kuaför Salonu",
    MakeupStudio: "Makyaj Stüdyosu",
    NailSalon: "Tırnak Salonu",
    BarberShop: "Berber Dükkanı",
  };

  const normalizedKey = Object.keys(types).find(
    (key) => key.toLowerCase() === type.toLowerCase()
  );

  return normalizedKey ? types[normalizedKey] : type;
};

export const translateFinanceTypeToTurkish = (type: string): string => {
  const types: Record<string, string> = {
    Income: "Gelir",
    Expense: "Gider",
  };

  const normalizedKey = Object.keys(types).find(
    (key) => key.toLowerCase() === type.toLowerCase()
  );

  return normalizedKey ? types[normalizedKey] : type;
};

export const translateFinanceCategoryToTurkish = (category: string): string => {
  const categories: Record<string, string> = {
    Appointment: "Randevu",
    ProductSale: "Ürün Satışı",
    Rent: "Kira",
    Salary: "Maaş",
    Tip: "Bahşiş",
    Other: "Diğer",
  };

  const normalizedKey = Object.keys(categories).find(
    (key) => key.toLowerCase() === category.toLowerCase()
  );

  return normalizedKey ? categories[normalizedKey] : category;
};

export const translateThemeToTurkish = (theme: string): string => {
  const themes: Record<string, string> = {
    light: "Aydınlık Tema",
    dark: "Karanlık Tema",
  };

  const normalizedKey = Object.keys(themes).find(
    (key) => key.toLowerCase() === theme.toLowerCase()
  );

  return normalizedKey ? themes[normalizedKey] : theme;
};

export const translateAppointmentStatusToTurkish = (
  status: AppointmentStatus
): string => {
  const statuses: Record<AppointmentStatus, string> = {
    Pending: "Onay Bekliyor",
    Approved: "Bekleniyor",
    Completed: "Tamamlandı",
    Canceled: "İptal",
    NoShow: "Gelmedi",
  };

  const normalizedKey = Object.keys(statuses).find(
    (key) => key.toLowerCase() === status.toLowerCase()
  );

  return normalizedKey ? statuses[normalizedKey as AppointmentStatus] : status;
};
